import { css, styled } from "../../../../styles";

// Class applied to the antd Modal so it adopts portal typography/spacing.
export const ecgTracingModalCss = css({
  fontFamily: "$openSans !important",

  ".ant-modal-content": {
    padding: "$11 $12 !important",
  },

  // Close button (X) matched to the circular one used on the other graph
  // modals (CustomIconButton: 30x30, round, grey-50 hover).
  ".ant-modal-close": {
    width: "30px !important",
    height: "30px !important",
    borderRadius: "50% !important",
    display: "flex !important",
    alignItems: "center !important",
    justifyContent: "center !important",
    transition: "background-color 120ms ease",
  },
  ".ant-modal-close:hover": {
    backgroundColor: "$gray-50 !important",
  },
});

// Modal title block: title + recording date subtitle.
export const TitleBlock = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "$1",

  "& .title": {
    fontFamily: "$openSans",
    fontSize: "$text-xl",
    fontWeight: 500,
    color: "$black",
  },

  "& .subtitle": {
    fontFamily: "$openSans",
    fontSize: "$text-md",
    color: "$gray-90",
  },
});

// Body: controls (top) and info (bottom) stay put, only the graph scrolls.
// Sizes to its content but is capped at 82vh, so on tall screens there's no
// empty space below the graph, and on short screens the graph scrolls.
export const ModalBody = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "$9",
  maxHeight: "82vh",
  marginTop: "$9",
});

export const ControlsRow = styled("div", {
  flexShrink: 0,
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: "$6",
});

// Scrollable container around the graph. flex "0 1 auto" means it sizes to the
// graph's natural height (no empty space below it on tall screens) but can
// shrink and scroll vertically when the body hits its max height. The graph
// keeps its natural size and scrolls horizontally on its own.
export const GraphArea = styled("div", {
  flex: "0 1 auto",
  minHeight: 0,
  width: "100%",
  overflowY: "auto",

  "&::-webkit-scrollbar": { width: "10px" },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "$gray-60",
    borderRadius: "$pill",
  },
  "&::-webkit-scrollbar-track": { backgroundColor: "$gray-30" },
});

// Centered message shown in the graph area while the waveform loads or fails.
export const GraphMessage = styled("div", {
  width: "100%",
  height: "100%",
  minHeight: "200px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontFamily: "$openSans",
  fontSize: "$text-lg",
  color: "$gray-90",
});

export const InfoBar = styled("div", {
  flexShrink: 0,
  display: "flex",
  flexWrap: "wrap",
  gap: "$14",
  paddingTop: "$6",
});

export const InfoItem = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "$1",

  "& .value": {
    fontFamily: "$openSans",
    fontWeight: 600,
    fontSize: "$text-lg",
    color: "$black",
  },

  "& .label": {
    fontFamily: "$openSans",
    fontSize: "$text-md",
    color: "$gray-100",
  },

  "& .date": {
    fontFamily: "$openSans",
    fontSize: "$text-sm",
    color: "$gray-80",
  },
});
